import { render } from "./glo.vue?vue&type=template&id=727860ec&scoped=true"
import script from "./glo.vue?vue&type=script&lang=js"
export * from "./glo.vue?vue&type=script&lang=js"

import "./glo.vue?vue&type=style&index=0&id=727860ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727860ec"]])

export default __exports__